import * as constants from "../../services/content/content";
import { BannerVariant } from "@vg-constellation/angular-17/banner";
import { EstateProfile } from "@models/estateProfile.model";

export type GuidedFlowState = {
  [routeKey: string]: {
    [key: string]: any;
    onSubmit?: () => boolean;
    isEdit?: boolean;
    currentStep?: number;
  };
};

export type GlobalState = {
  modalSyncInProgress: boolean;
  modalSyncState: "error"|"success"|"loading"|"not-started",
  modalSyncMessage: string;
  bannerState: BannerState;
  estateProfile?: EstateProfile;
  guidedFlowState: GuidedFlowState;
  guidedFlowTempState: GuidedFlowState;
}

export type BannerState = {
  showBanner: boolean;
  bannerVariant: BannerVariant;
  bannerContent: string;
}

export const initialState: GlobalState = {
  modalSyncInProgress: false,
  modalSyncState: "not-started",
  modalSyncMessage: constants.VANILLA_MODAL_SAVING_DATA,
  bannerState: {
    showBanner: false,
    bannerVariant: "basic",
    bannerContent: "",
  },
  estateProfile: undefined,
  guidedFlowState: {},
  guidedFlowTempState: {}
}
